import React, { useEffect, useState } from 'react';
import { api } from '../context/AuthContext';

const STALE_DAYS = 30;

export default function AseTableStats({ connectionId }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [view, setView] = useState('stale');

  useEffect(() => {
    let alive = true;
    if (!connectionId) return undefined;
    setData(null); setErr('');
    api.get('/api/sap/basis/ase-stats', { params: { connectionId } })
      .then((r) => { if (alive) setData(r.data); })
      .catch((e) => { if (alive) setErr((e && e.response && e.response.data && e.response.data.error) || String(e.message || e)); });
    return () => { alive = false; };
  }, [connectionId]);

  const num = (v) => Number(v || 0).toLocaleString('en-US');
  const rows = (data && data.rows) || [];
  const stale = rows.filter((r) => r.ageDays >= STALE_DAYS).sort((a, b) => b.ageDays - a.ageDays);
  const big = rows.slice().sort((a, b) => b.rowCnt - a.rowCnt);
  const shown = (view === 'stale' ? stale : big).slice(0, 25);
  const tab = (k, label) => (
    <button onClick={() => setView(k)} style={{
      padding: '4px 10px', borderRadius: 8, fontSize: 12, cursor: 'pointer',
      border: '1px solid ' + (view === k ? '#0891b2' : '#cbd5e1'),
      background: view === k ? 'rgba(8,145,178,0.08)' : 'transparent', color: 'inherit',
      fontWeight: view === k ? 600 : 400,
    }}>{label}</button>
  );

  if (err) return <div style={{ marginTop: 18, fontSize: 12.5, color: '#dc2626' }}>{err}</div>;

  return (
    <div style={{ marginTop: 18, borderTop: '1px solid #e2e8f0', paddingTop: 14 }}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', marginBottom: 10 }}>
        <span style={{ fontSize: 12.5, fontWeight: 600 }}>Table stats</span>
        {tab('stale', 'Stale statistics (' + stale.length + ')')}
        {tab('big', 'Largest tables')}
        <span style={{ fontSize: 12, color: '#94a3b8' }}>
          {!data ? 'loading...' : (data.at
            ? 'snapshot ' + String(data.at).slice(0, 16).replace('T', ' ')
              + (data.comparedTo ? ' · delta vs ' + String(data.comparedTo).slice(0, 10) : ' · belum ada pembanding')
            : 'belum ada snapshot — jalankan job ase_stats_monthly')}
        </span>
      </div>
      {!shown.length
        ? <div style={{ fontSize: 12.5, color: '#94a3b8' }}>
            {view === 'stale' ? 'No table with statistics older than ' + STALE_DAYS + ' days.' : 'No data.'}
          </div>
        : (
          <div style={{ overflow: 'auto', maxHeight: '45vh', border: '1px solid #e2e8f0', borderRadius: 10 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
              <thead>
                <tr>
                  {['Table', 'Rows', 'Delta', 'Stats updated', 'Age'].map((h, i) => (
                    <th key={h} style={{
                      padding: '8px 10px', position: 'sticky', top: 0, background: '#0f172a', color: '#94a3b8',
                      textAlign: i === 0 ? 'left' : 'right', fontWeight: 600,
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {shown.map((r) => {
                  const old = r.ageDays >= 365;
                  const warn = r.ageDays >= STALE_DAYS;
                  const col = old ? '#dc2626' : (warn ? '#b45309' : 'inherit');
                  const td = { padding: '6px 10px', textAlign: 'right' };
                  const age = r.ageDays >= 365
                    ? (r.ageDays / 365).toFixed(1) + ' yr'
                    : r.ageDays + ' d';
                  return (
                    <tr key={r.table} style={{ borderTop: '1px solid #e2e8f0', color: col }}>
                      <td style={{ padding: '6px 10px', fontFamily: 'monospace' }}>{r.table}</td>
                      <td style={td}>{num(r.rowCnt)}</td>
                      <td style={{ ...td, color: r.delta == null ? '#94a3b8' : (r.delta > 0 ? '#047857' : 'inherit') }}>
                        {r.delta == null ? '—' : (r.delta > 0 ? '+' : '') + num(r.delta)}
                      </td>
                      <td style={{ ...td, fontFamily: 'monospace' }}>{r.lastStat}</td>
                      <td style={{ ...td, fontWeight: warn ? 700 : 400 }}>{age}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
}
